export default function StepsLayout({
  title,
  children
}: {
  title: string;
  children: any;
}) {
  return (
    <div className="h-full w-full flex flex-col p-4">
      <div className="flex">
        <div className="p-2 font-bold text-xl">{title}</div>
      </div>

      <div className="flex h-full justify-center items-center">{children}</div>
    </div>
  );
}
